import React from 'react';
import { Section } from '../ui/Section';
import { Check } from 'lucide-react';
export function SalesLetter() {
  return <Section className="bg-black" data-id="element-201">
      <div className="max-w-2xl mx-auto prose prose-invert prose-lg" data-id="element-202">
        <p className="text-xl text-zinc-300 leading-relaxed mb-8" data-id="element-203">
          <span className="text-white font-bold" data-id="element-204">Te pasa todo el tiempo:</span>{' '}
          Entrás a una reunión y sentís que no te escuchan. O peor, sentís que
          alguien te está mintiendo en la cara y no sabés cómo demostrarlo.
        </p>

        <p className="text-zinc-400 mb-8" data-id="element-205">
          Te quedás callado. Te guardás la bronca. Y volvés a casa pensando en
          todo lo que deberías haber dicho.
        </p>

        <h3 className="text-2xl font-bold text-white mb-6 border-l-4 border-yellow-500 pl-4" data-id="element-206">
          El problema no sos vos. Es que nadie te enseñó las reglas ocultas del
          juego.
        </h3>

        <p className="text-zinc-400 mb-12" data-id="element-207">
          La mayoría de la gente cree que el carisma es algo con lo que se nace.
          Que leer a las personas es un "don".{' '}
          <span className="text-yellow-500 font-bold bg-yellow-500/10 px-1" data-id="element-208">
            Mentira.
          </span>
        </p>

        <div className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl mb-12 relative overflow-hidden" data-id="element-209">
          <div className="absolute top-0 left-0 w-1 h-full bg-yellow-500" data-id="element-210" />
          <h4 className="text-xl font-bold text-white mb-4" data-id="element-211">
            El Descubrimiento
          </h4>
          <p className="text-zinc-300 mb-6" data-id="element-212">
            Después de años analizando patrones de comportamiento en entornos de
            alta presión, descubrí que existen{' '}
            <strong data-id="element-213">3 pilares fundamentales</strong> que separan a quienes
            dominan de quienes son dominados:
          </p>
          <ul className="space-y-3" data-id="element-214">
            {['Lectura de Microexpresiones (lo que no dicen)', 'Control de Marco (quién dirige la charla)', 'Autoridad No Verbal (tu presencia física)'].map((item, i) => <li key={i} className="flex items-center gap-3 text-zinc-300" data-id="element-215">
                <div className="w-6 h-6 rounded-full bg-yellow-500/20 flex items-center justify-center flex-shrink-0" data-id="element-216">
                  <Check className="w-4 h-4 text-yellow-500" data-id="element-217" />
                </div>
                {item}
              </li>)}
          </ul>
        </div>

        <p className="text-xl text-white font-medium text-center" data-id="element-218">
          Empaqueté todo este conocimiento en un sistema paso a paso. Sin
          relleno. Solo tácticas que podés usar hoy mismo.
        </p>
      </div>
    </Section>;
}